export enum TasksEditSection {
    Task = 'TASK',
    Intervals = 'INTERVALS'
};

export enum TasksEditOrigin {
    Table = 'TABLE',
    Errors = 'ERRORS'
};
